// Catalogue information only, not measurements or a performance curve for the
// assembled system. Do not interpolate a flow or droplet size from these points.
export const microLineNozzle = Object.freeze({
  manufacturer: "M.R.S.",
  name: "M.R.S. Anti-Tropf-Keramikdüse · 0,2 mm",
  sourceUrl: "https://www.mrs-shop.com/m.r.s.-anti-tropf-keramik-nebelduese-mit-t-steckverteiler",
  orificeMm: .2,
  pressureRangeBar: Object.freeze([0, 20]),
  workingPressureBar: Object.freeze([12, 20]),
  referenceFlows: Object.freeze([
    Object.freeze({ pressureBar: Object.freeze([15, 20]), flowMlPerMin: 30 })
  ]),
  material: Object.freeze({ body: "Messing, vernickelt", head: "Edelstahl", inlet: "Keramik" }),
  connection: "T-Steckverteiler für 6 / 4 mm Schlauch",
  installedConnectionVariant: null,
  dropletClaim: null,
  measuredSystemFlow: null,
  measuredSystemDropletSize: null
});
